document.addEventListener('DOMContentLoaded', ()=>{
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const mediaThumbEl = document.querySelector('.type__product_thumb_swiper.swiper');
  if (mediaThumbEl){
    var MediaThumbnailView = new Swiper('.type__product_thumb_swiper.swiper', {spaceBetween:12,slidesPerView:'auto',watchSlidesProgress: true});
  }
  const mediaEl = document.querySelector('.type__product_main_swiper.swiper');
  if (mediaEl){
    const mediaConfig = {spaceBetween:0,slidesPerView:1,pagination:{el:'.swiper-pagination',type:'progressbar'},navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },thumbs: {swiper: MediaThumbnailView} };
    new Swiper(mediaEl, mediaConfig);
  }

  const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
  if (testimonialEl) {
    const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
    if (!isIOS) {
      testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      testimonialConfig.freeMode = true;
    }
    new Swiper(testimonialEl, testimonialConfig);
  } 

  const reviewsScrollarEl = document.querySelector('.page__reviews__swp.swiper');
  if (reviewsScrollarEl) {
    const reviewsScrollarConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
    if (!isIOS) {
      reviewsScrollarConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      reviewsScrollarConfig.freeMode = true;
    }
    new Swiper(reviewsScrollarEl, reviewsScrollarConfig);
  }   

  class PurchaseSelection extends HTMLElement {
    constructor() {
      super();
      this.dynamicBoxId = null;
    }
    async connectedCallback() {
      this.attachEvents();
      
      this.mainWrapper = document.querySelector(`.type__pdp_main_wrapper`);
      this.MainproductId = this.mainWrapper ? this.mainWrapper.dataset.bundleProductId : null;
      this.MainproductVariantId = this.mainWrapper ? this.mainWrapper.dataset.bundleMainId : null;
      this.MainproductSellingId = this.mainWrapper ? this.mainWrapper.dataset.sellingPlan : null;
      this.uniqID = new Date().getTime().toString();
      this.bundleID = this.getGuid();
      this.mainProperties = {
        _bundle_id: this.bundleID,
        _bundle_parent: "true",
        _uniq_id:this.uniqID
      };                 

      if (this.MainproductId) {
        this.dynamicBoxId = await this.getDynamicBoxId(this.MainproductId);
        this.dynamicBoxIndex = await this.calculateDynamicBoxIndex(this.dynamicBoxId);
      }
    }    
    attachEvents() {

      if( this.querySelectorAll('[js-byob-selection-option] input').length > 0 ){
        this.querySelectorAll('[js-byob-selection-option] input').forEach(el => {
          el.addEventListener('change', (e) => {
            e.preventDefault();
            this.targetWrap = e.currentTarget.closest('.Purchase__normally_wy');
            e.currentTarget.closest('.byob__selectionOptions__typepdp').querySelectorAll('.Purchase__normally_wy').forEach(el => el.classList.remove('active'));
            this.targetWrap.classList.add('active');
            this.paymentOption();
            this.priceChangeOfAtc();
          });
        });
      }

      if( this.querySelectorAll('[js-byob-purchase-option] input').length > 0 ){
        this.querySelectorAll('[js-byob-purchase-option] input').forEach(el => {
          el.addEventListener('change', (e) => {
            e.preventDefault();
            this.targetWrap = e.currentTarget.closest('.Purchase__normally_wy');
            e.currentTarget.closest('.byob__purchaseOptions__typepdp').querySelectorAll('.Purchase__normally_wy').forEach(el => el.classList.remove('active'));
            this.targetWrap.classList.add('active');
            this.priceChangeOfAtc();
          });
        }); 
      }

      this.addBtn = this.querySelector('.product-form__submit[name="add"]');
      if (this.addBtn) {
        this.addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if( (this.querySelectorAll(`.PurchaseOptions__container.byob__purchaseOptions__typepdp`).length > 0) && (this.querySelector(`[name="purchase-option"]:checked`).value === 'Byob-onetime')){
            // this.MainBundleCartItem = {
            //     id: this.MainproductVariantId,
            //     quantity: 1,
            //     properties:this.mainProperties
            // };             
            this.productAddingCartOneTime();
          }else{
            // this.MainBundleCartItem = {
            //     id: this.MainproductVariantId,
            //     quantity: 1,
            //     selling_plan:this.MainproductSellingId,
            //     properties:this.mainProperties
            // };             
            this.productAddingCartSubscribe();
          }
        });
      }      

    }
    paymentOption(){
      this.currentIndex = this.querySelector(`[js-byob-selection-option].active`).getAttribute(`selection-option-index`);
      this?.querySelectorAll(`[js-byob-purchase-option]`).forEach((el)=>{ el.classList.add('hidden'); el.classList.remove('active')});
      this?.querySelector(`[buyonce-option-index="${this.currentIndex}"]`)?.classList.remove('hidden');
      this?.querySelector(`[subscribe-option-index="${this.currentIndex}"]`)?.classList.remove('hidden');
      this?.querySelector(`[subscribe-option-index="${this.currentIndex}"]`)?.classList.add('active');
      this.querySelector(`[subscribe-option-index="${this.currentIndex}"]`).querySelector(`[name="purchase-option"]`).checked = true;
    }
    priceChangeOfAtc(){ 
      if( this.querySelectorAll(`.PurchaseOptions__container.byob__purchaseOptions__typepdp`).length == 0 ){
        this.compareAtPrice = [...this.querySelectorAll('input[name="Size-byob"]:checked')].map(input => input.dataset.cp.trim());
        this.Price = [...this.querySelectorAll('input[name="Size-byob"]:checked')].map(input => input.dataset.pp.trim());
      }else{
        this.compareAtPrice = [...this.querySelectorAll('input[name="purchase-option"]:checked')].map(input => input.dataset.cp.trim());
        this.Price = [...this.querySelectorAll('input[name="purchase-option"]:checked')].map(input => input.dataset.pp.trim());
      }
      this.customAtcText = this.querySelector('.product-form__submit[name="add"]').dataset.customText;
      this.querySelector('.product-form__submit[name="add"]').querySelector(`.btn_txt_wp`).innerHTML = `${this.customAtcText} —&nbsp;${this.Price[0]}&nbsp;${this.compareAtPrice[0] === '0' ? `` : `<s>${this.compareAtPrice[0]}</s>`}`;
    }
    productAddingCartOneTime(){
      this.bundleKey = document.querySelector(`.purchaseSubscribe_layoutWidget.active`).querySelector(`[name="Size-byob"]`).dataset.bundleKey;
      this.bundleJson = window.BundleCollection[this.bundleKey];
      this.itemsToAddToCart = this.bundleJson.items.map(item => {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: { 
            _dynamicBoxId: this.dynamicBoxId, 
            _dynamicBoxIndex: this.dynamicBoxIndex, 
            _original_qty: 1, 
            _uniq_id: this.uniqID 
          }
        };
      });

      // this.itemsToAddToCart.push(this.MainBundleCartItem);
      this.goingBundleCart(this.itemsToAddToCart);
    }
    productAddingCartSubscribe(){
      this.bundleKey = document.querySelector(`.purchaseSubscribe_layoutWidget.active`).querySelector(`[name="Size-byob"]`).dataset.bundleKey;
      this.bundleJson = window.BundleCollection[this.bundleKey];
      this.itemsToAddToCart = this.bundleJson.items.map(item => {
        return {
          id: item.id,
          quantity: item.quantity, 
          selling_plan:item.selling_plan,
          properties: { 
            _dynamicBoxId: this.dynamicBoxId, 
            _dynamicBoxIndex: this.dynamicBoxIndex, 
            _original_qty: 1, 
            _uniq_id: this.uniqID 
          }
        };
      });
      
      // this.itemsToAddToCart.push(this.MainBundleCartItem);
      this.goingBundleCart(this.itemsToAddToCart);      
    }
    goingBundleCart(bundleCart){
      this.cartDrawer = document.querySelector("cart-drawer");
      this.addBtn.disabled = true;
      if (this.cartDrawer) document.querySelector("cart-drawer").enableLoading();   
      const sections = this.cartDrawer?.getSectionsToRender()?.map(s => s.section) || [];
      this.BuildBundleOwn = {
        items: bundleCart,
        sections: sections.join(','),
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(this.BuildBundleOwn),
          credentials: 'same-origin'
        })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.sections && this.cartDrawer) {
            this.cartDrawer.renderContent(parsedState.sections);
          }
        })
        .catch((e) => {
          console.error("Fetch error:", e);
        })
        .finally(() => {
          this.addBtn.disabled = false;
          if (this.cartDrawer) {
            this.cartDrawer.disableLoading();
            this.cartDrawer.open();
          }
        });

    }
    getGuid(){
      let d = new Date().getTime();
      let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
      });      
    } 
    async getDynamicBoxId(productPlatformId) {
      try {
        const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productPlatformId: productPlatformId })
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        return data.DynamicBox?.boxId || null;
      } catch (error) {
        console.error('Error fetching dynamic box ID:', error);
        return null;
      }
    }
    async calculateDynamicBoxIndex(dynamicBoxId) {
      if (!dynamicBoxId) return 0;
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const existingIndices = [];
        cart.items.forEach(item => {
          if (item.properties && item.properties._dynamicBoxId === dynamicBoxId) {
            const index = parseInt(item.properties._dynamicBoxIndex);
            if (!isNaN(index)) {
              existingIndices.push(index);
            }
          }
        });
        if (existingIndices.length === 0) {
          return 0;
        }
        const maxIndex = Math.max(...existingIndices);
        return maxIndex + 1;
      } catch (error) {
        console.error('Error calculating dynamic box index:', error);
        return 0;
      }
    }    
  }
  customElements.define('cus-selection-byobs', PurchaseSelection);

  if ( document?.querySelectorAll('.rainforest__bundle__include_overlay')?.length > 0 ){
    document.querySelector('.rainforest__bundle__include_overlay span').addEventListener('click', (target)=>{
        target.preventDefault();
        target.target.closest('.rainforest__bundle_includes_interior').querySelectorAll('.rainforest__bundle_include_container').forEach((el)=>{el.classList.remove('hidden')});
        target.target.closest('.rainforest__bundle_includes_interior').querySelector('.rainforest__bundle__include_overlay').classList.add('hidden');
    });    
  }

  if ( document?.querySelectorAll('.table__standards__chart__brief_swp.swiper')?.length > 0 ){
    document?.querySelectorAll('.table__standards__chart__brief_swp.swiper')?.forEach((swiperinitilize , index) => {
      new Swiper(swiperinitilize, {
        slidesPerView: 'auto',spaceBetween: 8,
        pagination: { el: `.tb_nav_control-${index} .swiper-pagination.pagination_table_chart`, clickable: true },
        navigation: { nextEl: `.tb_nav_control-${index} .swiper-button-next.next_table_chart`, prevEl: `.tb_nav_control-${index} .swiper-button-prev.prev_table_chart` }         
      });
    }); 
  }  

  if ( document?.querySelectorAll('.table__standards__tab_name').length > 0 ){
    document?.querySelectorAll('.table__standards__tab_name').forEach((el)=>{
      el.addEventListener('click', (target)=>{
        target.preventDefault();
        let tableIndex = target.currentTarget.dataset.tableIndex;
        document.querySelectorAll(`.table__standards__content_wp`).forEach((tb)=>{tb.classList.remove('active')});
        document.querySelectorAll(`.table__standards__tab_name`).forEach((tb)=>{tb.classList.remove('active')});
        target.currentTarget.classList.add('active');
        document.querySelector(`.table__standards__content_wp[data-table-content="${tableIndex}"]`).classList.add('active');
      })
    })
  }

  if( document.querySelectorAll('.video__playIcon').length > 0 ){
    document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
      })
    });  
  }

  if( document.querySelectorAll('.video__playIcon__mnbanner').length > 0 ){
    document.querySelectorAll('.video__playIcon__mnbanner .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.target.closest('.thisControls__playpause').classList.contains('showOnDesk') ){
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon__mnbanner').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.page__shopping_banner').querySelector('video.showOnDesk').pause();
        }else if( target.target.closest('.thisControls__playpause').classList.contains('showOnMob') ){
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon__mnbanner').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.page__shopping_banner').querySelector('video.showOnMob').pause();
        }
      })
    });
    document.querySelectorAll('.video__playIcon__mnbanner .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.target.closest('.thisControls__playpause').classList.contains('showOnDesk') ){
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon__mnbanner').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.page__shopping_banner').querySelector('video.showOnDesk').play();
        }else if( target.target.closest('.thisControls__playpause').classList.contains('showOnMob') ){
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon__mnbanner').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.page__shopping_banner').querySelector('video.showOnMob').play();
        }
      })
    });    
  }  

  if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
    document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
      elm.addEventListener('click',(target)=>{
        target.preventDefault();
        let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
        document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
        document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    })   
  }
  
  class doctorDietitian extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
        elm.addEventListener('click',(target)=>{
          target.preventDefault();
          document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
          document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })       
    }
  }
  window.customElements.define('cus-dietitian-widget',doctorDietitian);  

  function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
    const scrollingContent = document.getElementById(contentId);
    if (!scrollingContent) {
      console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
      return;
    }
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
      return;
    }
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= speed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    container.addEventListener("mouseenter", () => { isPaused = true; });
    container.addEventListener("mouseleave", () => { isPaused = false; });
    animate();
  }
  setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 });

  if( document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').length > 0 ){
    document.querySelectorAll('a[href*="/type__pdp_main_wrapper"]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const dynamicAttribute = event.target.getAttribute('href').split('/')[1];
        const targetElement = document.querySelector(`.${dynamicAttribute}`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('[js-scroll-pdp-section]').length > 0 ){
    document.querySelectorAll('[js-scroll-pdp-section]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const targetElement = document.querySelector(`.type__pdp_main_wrapper`);
        const sectionHeader = document.querySelector('.section-header');
        if (!targetElement || !sectionHeader) return;
        const totalTop = sectionHeader.clientHeight;
        window.scrollTo({
          top: targetElement.offsetTop - totalTop,
          behavior: 'smooth'
        });
      });
    });
  } 

  if( document.querySelectorAll('.Testimonial_button_reviews').length > 0 ){
    document.querySelectorAll('.Testimonial_button_reviews').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        const targetElementRv = document.querySelector(`.custom__product__widget`);
        const sectionHeaderRv = document.querySelector('.section-header');
        if (!targetElementRv || !sectionHeaderRv) return;
        const totalTopRv = sectionHeaderRv.clientHeight;
        window.scrollTo({
          top: targetElementRv.offsetTop - totalTopRv,
          behavior: 'smooth'
        });        
      })
    })
  }  

function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
  const header = document.querySelector('.section-header');
  const headerHeight = header ? header.clientHeight : 0;
  const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
  const footerSections = document.querySelectorAll('.footer__main_wrapper');
  const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
  
  function shouldHideSticky() {
    for (const el of [...addToCartElements, ...footerSections, ...recentlyViewedSections]) {
      if (el && isInViewport(el)) return true;
    }
    return false;
  }
  
  function handleStickyScroll() {
    const scrollY = window.scrollY;
    const triggerElement = document.querySelector('[js-scroll-identity]');
    if (!triggerElement || !stickyBar) return;
    const triggerOffset = triggerElement.offsetTop;
    if (scrollY > triggerOffset) {
      if (shouldHideSticky()) {
        stickyBar.classList.remove('stickyAddToCart');
        stickyBar.style.top = `-100%`;
      } else {
        stickyBar.classList.add('stickyAddToCart');
        stickyBar.style.top = `${headerHeight}px`;
      }
    } else {
      stickyBar.classList.remove('stickyAddToCart');
      stickyBar.style.top = `-100%`;
    }
  }
  window.addEventListener('scroll', handleStickyScroll, { passive: true });

  const stickyButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
  const scrollTarget = document.querySelector('cus-selection-variants');
  if (stickyButton && header && scrollTarget) {
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      const offset = scrollTarget.offsetTop - header.clientHeight;
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }

  if( document.querySelectorAll('[js-offer-initiate-popup]').length > 0 ){
    document.querySelectorAll('[js-offer-initiate-popup]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelector('.entrance_offer__mainwrapper').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    }); 
  }   

  class enteranceOfferPopup extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[js-cross-entrance-offer]').addEventListener('click', this.crossEnteranceOffer.bind(this));
      this.querySelectorAll(`[js-validation-check]`).forEach((el)=>{el.addEventListener('change', this.debugEnteranceOffer.bind(this)) });
      this.querySelector('[js-sflow-entrance-offer]').addEventListener('click', this.sflowEnteranceOffer.bind(this));
    }
    crossEnteranceOffer(){
      this.querySelector('.entrance_offer__mainwrapper').classList.remove('active');
      document.querySelector('.page-overlay').classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
    }
    selectionEnteranceOffer(target){
      this.querySelectorAll('[js-selection-check]').forEach((el)=>{el.closest('.healthcare_fsflow__optionxt').classList.remove('active')});
    }
    debugEnteranceOffer(target){
      this.stringRegex = /^[A-Za-z\s]*$/;
      this.stringRegexSC = /^[A-Za-z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
      if( target.target.getAttribute('name') == 'entrancePractitionerFirstName' ){
        this.firstName = target.target.value;
        this.firstName = this.firstName.trim();
        if( !this.stringRegex.test(this.firstName) ){
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }
      }else if( target.target.getAttribute('name') == 'entrancePractitionerEmail' ){
        this.Email = target.target.value;
        this.Email = this.Email.trim();
        this.Email = this.Email.toLowerCase();
        this.email$CodeRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if ( this.Email.length === 0  ){
          target.target.classList.remove('notvalid','empty_error');
        }else if ( !this.Email.includes('.com') &&
          !this.Email.includes('.org') &&
          !this.Email.includes('.edu') &&
          !this.Email.includes('.gov') &&
          !this.Email.includes('.net') &&
          !this.Email.includes('.int') &&
          !this.Email.includes('.mil') &&
          !this.Email.includes('.arpa') &&
          !this.Email.includes('.amex') &&
          !this.Email.includes('.art') &&
          !this.Email.includes('.co')
        ) {
          target.target.classList.add('notvalid');
        }else if (!this.email$CodeRegex.test(this.Email)) {
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }  
      }
    }
    async sflowEnteranceOffer(target){
      this.AllCorrections = [];
      target.target.closest('.entrance_scflow__content').querySelectorAll('input').forEach((el)=>{
        this.emptyCheck = el.value.trim();
        if(el.value == ''){
          el.classList.add('empty_error');
        }else if( el.classList.contains('notvalid') ){
          el.classList.add('empty_error');
        }else{
          this.AllCorrections.push('true')
        }
      })

      if( this.AllCorrections.length == 2 ){
        this.targetEl = target.target;
        this.AcceptFirstName = target.target.closest('.entrance_scflow__content').querySelector('input[name="entrancePractitionerFirstName"]')?.value?.trim() || '';
        this.AcceptEmail = target.target.closest('.entrance_scflow__content').querySelector('input[name="entrancePractitionerEmail"]')?.value?.trim() || ''; 
        this.KlaviyoListId = this.targetEl.dataset.klaviyoListId.trim();
        this.RedirectUrl = this.targetEl.dataset.url;
        if( this.KlaviyoListId != '' ){
          this.targetEl.style.pointerEvents = 'none';
          this.payload = {
              data: {
                  type: 'subscription',
                  attributes: {
                      profile: {
                          data: {
                              type: 'profile',
                              attributes: {
                                  properties: {
                                      'SMS Consent': 'FALSE'
                                  },
                                  email: this.AcceptEmail,
                                  first_name: this.AcceptFirstName
                              }
                          }
                      }
                  },
                  relationships: {
                      list: {
                          data: {
                              type: 'list',
                              id: this.KlaviyoListId
                          }
                      }
                  }
              }
          };
          try {
            this.response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UFRh4Z', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'REVISION': '2024-07-15'
              },
              body: JSON.stringify(this.payload)
            });
            if (!this.response.ok) {
              throw new Error(`Request failed. Status: ${this.response.status}`);
            }
            this.responseText = await this.response.text();
            this.querySelector('.entrance_offer__mainwrapper').classList.remove('active');
            document.querySelector('.page-overlay').classList.remove('is-visible');
            document.body.classList.remove('overflow-hidden');
            this.targetEl.style.pointerEvents = 'auto';
            window.location.href = this.RedirectUrl;
            if (this.responseText) { 
              try {
                const json = JSON.parse(this.responseText);
              } catch (err) {
                console.error('Invalid JSON response:', err);
              }
            } else {
              console.log('Response was empty');
            }
          } catch (error) {
            console.error('Submission error:', error);
          }
        }
      }
    }
  }
  customElements.define('popup-entrance-offer', enteranceOfferPopup); 
  
})